import React, { useState } from 'react';
import { TermsModal } from './TermsModal';
import { PrivacyModal } from './PrivacyModal';
export function Footer() {
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm" data-id="element-62">
        <div className="container mx-auto px-4" data-id="element-63">
          <p className="mb-4 font-serif text-lg text-white" data-id="element-64">
            Casa Impecable con 2 Ingredientes
          </p>
          <p className="mb-8" data-id="element-65">Desarrollado por Emily Graterol</p>

          <div className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-66">
            <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-67">
              Política de Privacidad
            </button>
            <button onClick={() => setIsTermsOpen(true)} className="hover:text-white transition-colors cursor-pointer" data-id="element-68">
              Términos y Condiciones
            </button>
            <a href="#offer" className="hover:text-white transition-colors" data-id="element-69">
              Garantía
            </a>
          </div>

          <p className="text-xs text-gray-600" data-id="element-70">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-71" />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-72" />
    </>;
}